import { render, staticRenderFns } from "./sidebarGroupChatSM.vue?vue&type=template&id=b7e4e8d8&scoped=true"
import script from "./sidebarGroupChatSM.vue?vue&type=script&lang=js"
export * from "./sidebarGroupChatSM.vue?vue&type=script&lang=js"
import style0 from "./sidebarGroupChatSM.vue?vue&type=style&index=0&id=b7e4e8d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e4e8d8",
  null
  
)

export default component.exports